import { useQuery } from '@tanstack/react-query';
import { addGoalsToGlobalGoalsMap } from 'actions/globalGoalsMapActions';
import { useDispatch, useSelector } from 'react-redux';
import { selectLoggedInEmployeeData } from 'selectors/loggedInEmployee';

import { TEAM_TASKS_VIEW_TYPES, TEAM_TYPE } from 'constants/ProjectConstants';
import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { getTimeBoundTimePeriods } from 'services/admin';
import { fetchGoals } from 'services/analytics/goal';

import { getMySummaryGoals } from '../services';

export const useMySummaryGoals = ({
  employeeId,
  limit,
  offset,
  timeBounds = null,
  enabled = true,
  keepPreviousData = false,
  refetchOnWindowFocus = true,
}) =>
  useQuery(
    [REACT_QUERY_KEYS.mySummary.mySummaryGoals, employeeId, limit, offset, timeBounds],
    () => getMySummaryGoals({ employeeId, limit, offset, timeBounds }),
    {
      enabled,
      keepPreviousData,
      refetchOnWindowFocus,
    }
  );
export const useMySummaryGoalsV1 = ({
  limit,
  offset,
  timeBounds = null,
  enabled = false,
  keepPreviousData = false,
  refetchOnWindowFocus = true,
}) => {
  const dispatch = useDispatch();

  const loggedInEmployeeData = useSelector(selectLoggedInEmployeeData);

  const personalTeam = loggedInEmployeeData?.teams.find((team) => team.teamType === TEAM_TYPE.personal);

  const selectedCohort = {
    id: personalTeam?.id,
    uuid: String(personalTeam?.id),
    createdTS: null,
    updatedTS: null,
    organization: null,
    employee: null,
    name: 'My Goals',
    query: {
      function: null,
      grade: null,
      gender: null,
      ethnicity: null,
      location: null,
      designations: null,
      provider: null,
      functionId: null,
      roleId: null,
      teamId: {
        id: String(personalTeam?.id),
        displayName: String(personalTeam?.id),
      },
      goals: null,
      engagement: null,
      review: null,
      oneOnOne: null,
      feedback: null,
      competency: null,
    },
    baseCohort: null,
    visibilityType: null,
    message: null,
    type: 'MY_OKRs',
    isPinned: null,
    pinnedAt: null,
  };

  return useQuery(
    [REACT_QUERY_KEYS.mySummary.mySummaryGoals, limit, offset, timeBounds],
    async () => {
      const goals = await fetchGoals({
        limit,
        offset,
        selectedCohort,
        timeBounds,
        resourceType: TEAM_TASKS_VIEW_TYPES.goalTree,
        isPrivateGoalRequired: true,
      });
      dispatch(addGoalsToGlobalGoalsMap({ goals }));
      return goals;
    },
    {
      enabled,
      keepPreviousData,
      refetchOnWindowFocus,
    }
  );
};
const TwelveHoursInMs = 1000 * 60 * 60 * 12;
export const useTimeBoundTimePeriods = () =>
  useQuery([REACT_QUERY_KEYS.okrsTimelineData], () => getTimeBoundTimePeriods(), {
    staleTime: TwelveHoursInMs,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  });
